/* THE TICK BOX. "This is painfully me." under every shirt and hoodie card.
   Board job 336, built 1 Oct 2026 by T11 on Adam's go. Every detail is his
   own pick off five preview pages that evening: the place (under the sentence),
   his own words, the small box, the meh face, the words after the tick, and
   no number before it.

   WHAT A VISITOR SEES. Right under the sentence, one small grey line: an empty
   box and "This is painfully me." No number shows until they press it. Pressed,
   the box turns brown with a little meh face in it (his own :\ drawn upright:
   two dots and a mouth sliding down) and the words become the count, in brown:
   "Just you so far." for the first person, "You and 1 other." for the second,
   "You and 188 others." after that. Pressing again in the same visit takes it
   back. After a refresh it stays ticked and locked: the same person who comes
   back can never undo it or tick it twice (his word 1 Oct 2026 ~23:15).

   ONE COUNT PER SENTENCE, his pick 1 Oct 2026 ~23:20: a shirt and its hoodie
   share it. A hoodie's address is its shirt's address plus -1 (true for all
   103 pairs, checked against the live shop that night, and no shirt address
   ends in -1), so the -1 comes off and both cards ask for the same count.

   WHERE THE COUNTS LIVE. A small store on his own Cloudflare, free
   (whateverrr/tick-counter/, worker wr-tick, read its header). Since 2 Oct
   2026 every card shows its count to everyone (his word: "people will see
   what other people chose"), so the page asks for the counts of every
   sentence on it, 80 to a request.

   WHO TICKED. No login. The browser gets a random id the first time it ticks
   and keeps it, with the list of sentences it ticked, in localStorage. The
   store refuses the same (sentence, id) pair twice. A browser that cannot
   keep anything (a private window on an old phone) still works for the visit.

   WHICH CARDS. Every card on the site shares one buy row (assets/wr-buy.js
   draws the price and ADD into every .wr-buy), so this file looks for those
   rows and gives each card its box: both home pages, the Everything page, the
   group pages, search, the "Two is a personality." strip. The shirt's own page
   has no buy row (his call 8 Sep 2026) and gets no box, his ask: the cards,
   not the page. The one shirt and one hoodie features on the home page draw
   their own ADD button, not a buy row, so they carry no box either.

   WHERE ON THE CARD, and this is the part that took measuring. In the picture
   he approved the box HUGS THE SENTENCE, 7px under it, and the two sit together
   in the room the card keeps for a sentence. Drawn at the top of the buy row
   it sat down by the thin line instead, far from a one-line sentence, because
   most cards keep room for two lines. So, measured on the live shop 1 Oct 2026
   for every kind of card, the box goes:
     - INTO the sentence's own box, under the sentence, when that box is a
       plain div (the home page cards). A box that lays its sentence out as a
       row is turned into a column, keeping the sentence where it was (middle
       or top). On the computer home cards the 58px that box already keeps
       holds two lines and the tick, so the card does not grow at all, exactly
       like his picture. Where the room is too small it grows by one tick line.
     - INTO A NEW BOX AROUND THE SENTENCE when the sentence is a link (the
       Everything page), because a button cannot live inside a link. The new
       box takes over the room and the margins the link had, plus one tick
       line, so the sentence does not move and the air under the pair is the
       air that was under the sentence.
     - AT THE TOP OF THE BUY ROW on the tilted photo cards, where the sentence
       and the row are each turned a degree or two: the box turns with the row.
     - JUST BEFORE THE BUY ROW on the theme's own cards (group pages, search,
       the strip under a shirt), so it stays under the sentence when the row
       is pushed to the bottom of a taller card.
     - anything else: the top of the buy row.
   Everything is read off the page's own styles when the box is drawn, so a
   card that changes its numbers later still gets the box in the right place.

   THE ONE SWITCH is ON below. Set it to false and push this file to take every
   box off the site at once; nothing else has to change. Loaded from
   layout/theme.liquid right after wr-buy.js. */

(function () {
  if (window.wrTick) return;

  var ON = true;
  var API = 'https://wr-tick.whateverrr.workers.dev';
  var WORDS = 'This is painfully me.';
  var BROWN = '#B3967D';
  var INK = '#111';
  var GAP = 7;            /* px between the sentence and the box, his picture */

  if (!ON) return;

  /* his pick 1 Oct 2026 ~23:00, number 1 of six: the meh face on the brown box */
  var MEH = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<rect x="0" y="0" width="24" height="24" fill="' + BROWN + '"></rect>' +
    '<circle cx="8" cy="9.5" r="2" fill="' + INK + '"></circle>' +
    '<circle cx="16" cy="9.5" r="2" fill="' + INK + '"></circle>' +
    '<line x1="7.5" y1="15.5" x2="16.5" y2="18.5" stroke="' + INK + '" stroke-width="2.4" stroke-linecap="round"></line>' +
    '</svg>';

  /* THE LOOK, his picks: 11.5px, weight 600, the site's dim grey (#8d8d8d on
     black, #666 on a white band, the same two greys the buy row uses), a 12px
     box with a 1.5px edge, 7px between box and words, centred under the
     sentence. Ticked: brown, the box filled by the face. Phone: 10.5px, 15px
     box, 5px gap. THE PHONE BOX GREW 2 Oct 2026, his words: "The tick is too
     small. The sentence should stay the same." He picked number 2 of five
     sizes shot off real cards (16px computer, 15px phone, was 12 and 11), then
     the same hour: "On the website computer rollback box size to what it was
     original on the phone leave the changes". So the computer is 12px again
     and only the phone keeps the bigger box. The words did not change. On the
     phone the box is taller than the words, so the height the cards keep for
     the tick line there (--wr-tick-h, tickHeight) is the box.
     The hover only exists where there is a mouse, so a tap on a
     phone does not leave a box stuck brown. Every button reset is written out
     because the theme styles plain buttons of its own, and the font is named
     because some cards set their own. No colour is ever written into a style
     attribute (a site-wide line wipes those); the few numbers the script hands
     over go in as --wr-tick-... variables. */
  var CSS =
    '.wr-tick{display:flex;align-items:center;justify-content:var(--wr-tick-side,center);gap:7px;width:100%;margin:0;padding:0;' +
      'appearance:none;-webkit-appearance:none;background:transparent;border:0;border-radius:0;box-shadow:none;min-height:0;height:auto;' +
      'font-family:var(--font-body--family,Manrope,-apple-system,"Segoe UI",Helvetica,Arial,sans-serif);' +
      'font-size:11.5px;font-weight:600;font-style:normal;line-height:1.2;letter-spacing:0;text-transform:none;text-align:center;white-space:nowrap;' +
      'color:var(--wr-tick-dim,#8d8d8d);cursor:pointer;transition:color .15s}' +
    '.wrhr-on-white .wr-tick,.wrhp-on-white .wr-tick,.on-white .wr-tick{--wr-tick-dim:#666}' +
    '.wr-tick__box{position:relative;flex:0 0 auto;box-sizing:border-box;width:12px;height:12px;border:1.5px solid currentColor}' +
    '.wr-tick__box svg{position:absolute;left:-1.5px;top:-1.5px;width:12px;height:12px;display:block}' +
    '.wr-tick.is-on{color:' + BROWN + '}' +
    '.wr-tick.is-on .wr-tick__box{border-color:transparent}' +
    '.wr-tick.is-locked{cursor:default}' +
    '.wr-tick:focus{outline:none}' +
    '.wr-tick:focus-visible{outline:1px dotted ' + BROWN + ';outline-offset:2px}' +
    '@media (hover:hover){.wr-tick:hover:not(.is-locked){color:' + BROWN + '}}' +

    /* in the sentence's box, or in the new box around a sentence that is a link */
    '.wr-tick-box{--wr-tick-h:13.8px}' +
    '.wr-tick-box>.wr-tick{margin-top:' + GAP + 'px;flex:0 0 auto}' +
    '.wr-tick-box--col{flex-direction:column!important;flex-wrap:nowrap!important;' +
      'align-items:var(--wr-tick-across,center)!important;justify-content:var(--wr-tick-up,center)!important}' +
    '.wr-tick-box--pair{display:flex;flex-direction:column;align-items:stretch;justify-content:var(--wr-tick-up,center);' +
      'margin-top:var(--wr-tick-mt,0);margin-bottom:var(--wr-tick-mb,0);min-height:var(--wr-tick-room,0);min-width:0}' +
    '.wr-tick-box--grow{min-height:calc(var(--wr-tick-room,0px) + ' + GAP + 'px + var(--wr-tick-h))!important}' +
    '.wr-tick-sent{height:auto!important;min-height:0!important;margin:0!important;flex:0 0 auto}' +

    /* at the top of the buy row; on the computer's tilted cards the row's 26px
       of air comes down to 10 so the box sits 7px under the sentence */
    '.wr-buy>.wr-tick{margin-bottom:10px}' +
    '.wrhr .wrhr-bigcard .wr-buy.wr-tick-row{margin-top:10px}' +
    '.wrhp-bigcard .wr-buy>.wr-tick{margin-top:3px}' +

    /* just before the buy row, on the theme\'s own cards: the card puts its own
       gap between its parts, so the script hands over what is left to make 7px
       above the box and 10px under it */
    '.wr-tick--before{margin:var(--wr-tick-above,3px) 0 var(--wr-tick-under,6px)}' +

    '@media (max-width:640px){.wr-tick{font-size:10.5px;gap:5px}.wr-tick__box{width:15px;height:15px}.wr-tick__box svg{width:15px;height:15px}' +
      '.wr-tick-box{--wr-tick-h:15px}.wr-buy>.wr-tick{margin-bottom:8px}}';

  var style = document.createElement('style');
  style.id = 'wr-tick-css';
  style.textContent = CSS;
  (document.head || document.documentElement).appendChild(style);

  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 640px)') : { matches: false };
  function tickHeight() { return PHONE.matches ? 15 : 13.8; }

  /* WHAT THIS BROWSER REMEMBERS: its id and the sentences it ticked. Kept in
     localStorage so it survives a refresh; if the browser refuses, a copy in
     memory carries the visit. */
  var mem = {};
  function read(key) {
    try { var v = localStorage.getItem(key); if (v !== null) return v; } catch (err) { }
    return mem[key] === undefined ? null : mem[key];
  }
  function write(key, val) {
    mem[key] = val;
    try { localStorage.setItem(key, val); } catch (err) { }
  }

  function visitorId() {
    var v = read('wr_tick_v');
    if (v && /^[a-f0-9]{32}$/.test(v)) return v;
    var bytes = new Uint8Array(16);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(bytes);
    else for (var i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
    v = Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    write('wr_tick_v', v);
    return v;
  }

  function tickedList() {
    try {
      var o = JSON.parse(read('wr_tick_k') || '{}');
      return (o && typeof o === 'object') ? o : {};
    } catch (err) { return {}; }
  }
  function setTicked(k, on) {
    var o = tickedList();
    if (on) o[k] = 1; else delete o[k];
    write('wr_tick_k', JSON.stringify(o));
  }

  /* THE SENTENCE A ROW BELONGS TO. The row carries the product's address, as
     data-wr-handle (the live kind) or inside its JSON (the Liquid kind). A
     hoodie's address ends in -1; that comes off, so the shirt and the hoodie
     meet on one count. */
  function keyOf(row) {
    var h = row.getAttribute('data-wr-handle') || '';
    if (!h) {
      try {
        var d = JSON.parse(row.getAttribute('data-wr-buy'));
        h = String((d && d.u) || '').split('?')[0].split('/').pop();
      } catch (err) { h = ''; }
    }
    h = String(h).toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (!h) return '';
    return h.replace(/-1$/, '');
  }

  /* others = how many people ticked it, not counting you */
  function after(others) {
    if (others <= 0) return 'Just you so far.';
    if (others === 1) return 'You and 1 other.';
    return 'You and ' + others + ' others.';
  }

  var counts = {};      /* sentence -> how many ticks in all, once the store has said */
  var thisVisit = {};   /* sentence -> ticked during this page load, so it may still be unticked */
  var busy = {};        /* sentence -> a tick or untick is on its way to the store */
  var buttons = {};     /* sentence -> every box drawn for it on this page */

  function paint(btn) {
    var k = btn.getAttribute('data-wr-tick-key');
    var on = !!tickedList()[k];
    var locked = on && !thisVisit[k];
    btn.classList.toggle('is-on', on);
    btn.classList.toggle('is-locked', locked);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var box = btn.firstChild;
    var words = btn.lastChild;
    if (on) {
      if (!box.firstChild) box.innerHTML = MEH;
      /* the words change the moment the store has answered with the count;
         until then they stay as they were, in brown */
      words.textContent = (typeof counts[k] === 'number') ? after(counts[k] - 1) : WORDS;
    } else {
      /* EVERYONE SEES THE COUNT, his word 2 Oct 2026: "The idea is that people
         will see what other people chose!" In his first note's own shape,
         "This is painfully me. · 188"; nothing added while nobody has ticked. */
      box.innerHTML = '';
      words.textContent = (counts[k] > 0) ? WORDS + ' · ' + counts[k] : WORDS;
    }
  }

  function paintAll(k) {
    buttons[k] = (buttons[k] || []).filter(function (b) { return document.documentElement.contains(b); });
    buttons[k].forEach(paint);
  }

  /* ASKING THE STORE FOR COUNTS, all the sentences of one page in one go */
  var pending = {};
  var askTimer = null;
  function want(k) {
    pending[k] = 1;
    if (askTimer) return;
    askTimer = setTimeout(function () {
      askTimer = null;
      var keys = Object.keys(pending);
      pending = {};
      while (keys.length) ask(keys.splice(0, 80));
    }, 40);
  }
  function ask(keys) {
    fetch(API + '/n?k=' + encodeURIComponent(keys.join(',')), { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        if (!res) return;
        keys.forEach(function (k) {
          if (typeof res[k] === 'number') { counts[k] = res[k]; paintAll(k); }
        });
      })
      .catch(function () { });
  }

  function send(path, body) {
    return fetch(API + path, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* THE PRESS. The box flips at once; the words follow the store's answer. A
     box ticked on an earlier visit is locked and does nothing. If the store
     does not answer, the box goes back to how it was and nothing is kept. */
  function press(btn) {
    var k = btn.getAttribute('data-wr-tick-key');
    if (!k || busy[k]) return;
    var on = !!tickedList()[k];
    if (on && !thisVisit[k]) return;
    var turnOn = !on;
    busy[k] = 1;
    setTicked(k, turnOn);
    if (turnOn) thisVisit[k] = 1; else delete thisVisit[k];
    paintAll(k);
    send(turnOn ? '/tick' : '/untick', { k: k, v: visitorId() }).then(function (res) {
      if (res && typeof res.n === 'number') {
        counts[k] = res.n;
      } else {
        setTicked(k, on);
        if (on) thisVisit[k] = 1; else delete thisVisit[k];
      }
      delete busy[k];
      paintAll(k);
    });
  }

  function forget(btn) {
    var k = btn.getAttribute('data-wr-tick-key');
    if (buttons[k]) buttons[k] = buttons[k].filter(function (b) { return b !== btn; });
  }

  /* WORKING OUT WHERE THE BOX GOES ON THIS CARD. Reads only, nothing is
     changed here: every card on the page is looked at first and only then is
     anything drawn, so two hundred cards do not make the browser lay the page
     out two hundred times. The kinds are listed at the top of this file. */
  function wordsOnly(el) {
    if (el.querySelector('img, picture, video, svg, iframe, button, input, select, .wr-buy')) return false;
    return !!(el.textContent && el.textContent.replace(/\s+/g, ''));
  }

  /* a box that laid its sentence out as a ROW becomes a column: what was the
     up and down setting of the row is the same setting of the column */
  function upOf(alignItems) {
    if (alignItems === 'center') return 'center';
    if (alignItems === 'flex-end' || alignItems === 'end') return 'flex-end';
    return 'flex-start';
  }
  function acrossOf(justify) {
    if (justify === 'center' || justify === 'space-around' || justify === 'space-evenly') return 'center';
    if (justify === 'flex-end' || justify === 'end' || justify === 'right') return 'flex-end';
    return 'flex-start';
  }

  /* THE BOX STANDS WHERE THE SENTENCE STANDS: in the middle under a centred
     sentence (nearly every card), at the left under a sentence that reads from
     the left (the group pages). Read off the words themselves. */
  function sideOf(el) {
    var deep = el;
    for (var i = 0; deep && deep.firstElementChild && i < 4; i++) deep = deep.firstElementChild;
    if (!deep) return 'center';
    var ta = getComputedStyle(deep).textAlign;
    if (ta === 'center') return 'center';
    if (ta === 'right' || ta === 'end') return 'flex-end';
    return 'flex-start';
  }

  function plan(row) {
    var card = row.parentElement;
    if (!card) return { how: 'row' };
    /* the tilted photo cards: the box turns with the buy row */
    if (card.matches('.wrhr-bigcard, .wrhp-bigcard')) return { how: 'row', tight: true };

    /* the thing just before the buy row is the sentence, once anything hidden
       is stepped over (the theme's own price sits there, switched off) */
    var box = row.previousElementSibling;
    var cs = box ? getComputedStyle(box) : null;
    while (box && !box.__wrTickBox && cs.display === 'none') {
      box = box.previousElementSibling;
      cs = box ? getComputedStyle(box) : null;
    }
    if (box && box.__wrTickBox) return { how: 'again', box: box };

    var usable = box && cs.display !== 'none' && cs.display !== 'contents' &&
      (box.tagName === 'A' || box.tagName === 'DIV' || box.tagName === 'P') && wordsOnly(box);
    if (!usable) {
      if (!card.matches('.product-card__content')) return { how: 'row' };
      var between = parseFloat(getComputedStyle(card).rowGap) || 0;
      return {
        how: 'before',
        above: (GAP - between) + 'px',
        under: (10 - between) + 'px',
        side: (box && cs.display !== 'none' && wordsOnly(box)) ? sideOf(box) : 'center'
      };
    }

    var link = box.tagName === 'A';
    var words = link ? box : (box.firstElementChild || box);
    var ws = getComputedStyle(words);
    var size = parseFloat(ws.fontSize) || 13;
    var line = parseFloat(ws.lineHeight) || size * 1.37;
    var lines = ws.whiteSpace === 'nowrap' ? 1 : 2;
    /* the room the card keeps for a sentence: a min-height, or on a link a
       fixed height. If two lines and the tick fit in it, nothing grows. */
    var room = parseFloat(cs.minHeight) || 0;
    if (link) room = Math.max(room, parseFloat(cs.height) || 0);
    var grow = room > 0 && room < lines * line + GAP + tickHeight() + 2;
    var flex = cs.display.indexOf('flex') !== -1;
    return {
      how: link ? 'pair' : 'inside',
      box: box,
      room: room,
      grow: grow,
      row: flex && cs.flexDirection.indexOf('row') === 0,
      up: flex ? upOf(cs.alignItems) : 'flex-start',
      across: acrossOf(cs.justifyContent),
      mt: cs.marginTop,
      mb: cs.marginBottom,
      side: ws.textAlign === 'center' ? 'center' : sideOf(words)
    };
  }

  /* PUTTING IT THERE. Writes only. */
  function put(row, btn, p) {
    if (p.side && p.side !== 'center') btn.style.setProperty('--wr-tick-side', p.side);
    if (p.how === 'again') {
      p.box.appendChild(btn);
    } else if (p.how === 'inside') {
      var box = p.box;
      box.__wrTickBox = true;
      box.classList.add('wr-tick-box');
      if (p.row) {
        box.classList.add('wr-tick-box--col');
        box.style.setProperty('--wr-tick-up', p.up);
        box.style.setProperty('--wr-tick-across', p.across);
      }
      if (p.grow) {
        box.classList.add('wr-tick-box--grow');
        box.style.setProperty('--wr-tick-room', p.room + 'px');
      }
      box.appendChild(btn);
    } else if (p.how === 'pair') {
      /* the sentence is a link, and a button cannot live inside a link: a new
         box goes round the link and takes over the room and margins it had */
      var pair = document.createElement('div');
      pair.className = 'wr-tick-box wr-tick-box--pair' + (p.grow ? ' wr-tick-box--grow' : '');
      pair.__wrTickBox = true;
      pair.style.setProperty('--wr-tick-up', p.up);
      pair.style.setProperty('--wr-tick-mt', p.mt);
      pair.style.setProperty('--wr-tick-mb', p.mb);
      if (p.room) pair.style.setProperty('--wr-tick-room', p.room + 'px');
      p.box.parentNode.insertBefore(pair, p.box);
      pair.appendChild(p.box);
      p.box.classList.add('wr-tick-sent');
      pair.appendChild(btn);
    } else if (p.how === 'before') {
      btn.classList.add('wr-tick--before');
      btn.style.setProperty('--wr-tick-above', p.above);
      btn.style.setProperty('--wr-tick-under', p.under);
      row.parentNode.insertBefore(btn, row);
    } else {
      if (p.tight) row.classList.add('wr-tick-row');
      row.insertBefore(btn, row.firstChild);
    }
  }

  /* LOOKING AT ONE ROW. Only once the buy row has drawn its thin line, so a row
     whose product never loaded shows no lonely box; the next scan catches a
     row that was not ready. A row that already has its box is left alone,
     unless its product changed under it (the home page deals a new hand), and
     then the same box simply moves to the new sentence. */
  function look(row) {
    if (row.getAttribute('data-wr-page') === 'product') return null;
    if (!row.querySelector('.wr-buy__hr')) return null;
    var k = keyOf(row);
    var btn = row.__wrTick;
    if (btn && !document.documentElement.contains(btn)) { forget(btn); btn = row.__wrTick = null; }
    if (btn) {
      if (btn.getAttribute('data-wr-tick-key') === k) return null;
      forget(btn);
      if (!k) { btn.parentNode.removeChild(btn); row.__wrTick = null; return null; }
      btn.setAttribute('data-wr-tick-key', k);
      (buttons[k] = buttons[k] || []).push(btn);
      paint(btn);
      if (typeof counts[k] !== 'number') want(k);
      return null;
    }
    if (!k) return null;
    return { row: row, key: k, plan: plan(row) };
  }

  function make(job) {
    var k = job.key;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wr-tick';
    btn.setAttribute('data-wr-tick-key', k);
    btn.innerHTML = '<span class="wr-tick__box"></span><span class="wr-tick__words"></span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      press(btn);
    });
    put(job.row, btn, job.plan);
    job.row.__wrTick = btn;
    (buttons[k] = buttons[k] || []).push(btn);
    paint(btn);
    if (typeof counts[k] !== 'number') want(k);
  }

  function scan(root) {
    var where = root || document;
    var jobs = [];
    Array.prototype.forEach.call(where.querySelectorAll('.wr-buy'), function (row) {
      var job = look(row);
      if (job) jobs.push(job);
    });
    jobs.forEach(make);
  }

  window.wrTick = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* cards arrive after the page has loaded (the home page deals its hand, the
     buy rows fill in once their product is known), so watch for them the same
     way wr-buy.js does: once per screen frame, however much changed */
  if (window.MutationObserver) {
    var queued = false;
    var soon = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      soon(function () { queued = false; scan(); });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-wr-handle']
    });
  }
})();
